import React from 'react';
import './Features.css'; // Import the CSS file
import vertical from '../../assets/trimesh.jpg'
import { Box } from '@mui/material';
import CloudCompare from '../../assets/CloudCompare.jpg'
import three from '../../assets/Three.js.jpg'
import loco from '../../assets/Locomotiv.jpg'
import pytorch from '../../assets/PyTorch Geometric.jpg'
import pdal from '../../assets/PDAL (Point Data Abstraction Library).jpg'
import open from '../../assets/Open3D.jpg'
import tensorFlow from '../../assets/TensorFlow Graphics.jpg'
import scikit from '../../assets/Scikit-Geometry.jpg'
import pytorch3d from '../../assets/PyTorch3D.jpg'
import pcl from '../../assets/PCL.jpg'
import trimesh from '../../assets/trimesh.jpg'
import pyvista from '../../assets/PyVista.jpg'

const Features = () => {
  // const images1 = Array(18).fill(
  //   [loco, 'Locomotive'],
  // );
  // const images2 = Array(17).fill(
  //   "https://miro.medium.com/v2/resize:fit:720/format:webp/1*Iv5ntHstgQowxRl6PsNa9g.jpeg"
  // );
  const images1 = [
    [CloudCompare, 'CloudCompare'],
    [three, 'Three.js'],
    [loco, 'Locomotive'],
    [pytorch, 'PyTorch'],
    [pdal, 'PDAL'],
    [pytorch, 'PyTorch'],
    [open, 'Open3D'],
    [tensorFlow, 'TensorFlow'],
    [three, 'Three.js'],
    [scikit, 'Scikit-Geometry'],
    [pytorch3d, 'PyTorch3D'],
    [pcl, 'PCL'],
    [trimesh, 'trimesh'],
    [pytorch3d, 'PyTorch3D'],
    [loco, 'Locomotive'],
    [pyvista, 'PyVista'],
    [open, 'Open3D'],
    [open, 'Open3D'],
  ]
  const images2 = [
    [CloudCompare, 'CloudCompare'],
    [three, 'Three.js'],
    [loco, 'Locomotive'],
    [pytorch, 'PyTorch'],
    [pdal, 'PDAL'],
    [pytorch, 'PyTorch'],
    [open, 'Open3D'],
    [tensorFlow, 'TensorFlow'],
    [three, 'Three.js'],
    [scikit, 'Scikit-Geometry'],
    [pytorch3d, 'PyTorch3D'],
    [pcl, 'PCL'],
    [trimesh, 'trimesh'],
    [pytorch3d, 'PyTorch3D'],
    [loco, 'Locomotive'],
    [pyvista, 'PyVista'],
    [open, 'Open3D'],
  ]

  return (
    <>
      <div className="container">
        {/* Left Side */}
        <div className="side left">
          <h2>. Open-Access Datasets for Point Cloud ML</h2>
          <div className="image-grid">
            {images1.map((image, index) => {
              let className = "main";
              let imgSrc = image[0]; // Default image
              if (index === 10) { className += " span-1-2"; }
              if (index === 13) { className += " span-1-2"; }

              return (
                <div className={`image-wrapper1 ${className}`} key={index}>
                   <img src={imgSrc} alt={`Feature ${index + 1}`} className="feature-image" />
                  <div className="mask" />
                  <span className="feature-text">{image[1]}</span>
                </div>
              );
            }
            )}
          </div>
        </div>

        {/* Right Side */}
        <div className="side right">
          <h2>.  Tools for Point Cloud ML & Visualization</h2>
          <div className="image-grid">
            {images2.map((image, index) => {
              let className = "main";
              let imgSrc = image[0]; // Default image
              if (index === 7) className += " span-2-1";
              if (index === 9) className += " span-1-2";
              if (index === 12) className += " span-1-2";

              return (
                <div className={`image-wrapper1 ${className}`} key={index}>
                  <img src={imgSrc} alt={`Feature ${index + 1}`} className="feature-image1" />
                  <div className="mask" />
                  <span className="feature-text1">{image[1]}</span>
                </div>
              );
            })}
          </div>

        </div>

      </div>


    </>
  );
};

export default Features;
